import { styled } from 'styled-components'
import { onMediumScreen } from 'mixtiles-web-common'
import { ReactComponent as LaurelIcon } from './laurel.svg'

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 34px;
  padding: 40px 40px 0;
  background: ${({ theme }) => theme.colors.white};

  ${onMediumScreen()} {
    gap: 80px;
    padding: 120px clamp(40px, calc(100% * 120 / 1280), 120px);
  }
`

export const Title = styled.h2`
  margin: 0;
  max-width: 313px;
  font-size: 32px;
  line-height: 1.12;
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};

  ${onMediumScreen()} {
    max-width: none;
    font-size: 40px;
    line-height: 1.4;
  }
`

export const Stats = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 327px;

  ${onMediumScreen()} {
    flex-direction: row;
    /* Just above md the three stats are wider than the row; centered, they spill evenly into
       both side paddings instead of only the right one. */
    justify-content: center;
    gap: 24px;
    max-width: 1440px;
  }
`

export const Stat = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 30px;
  background: rgba(235, 231, 231, 0.3);
  height: 148px;

  ${onMediumScreen()} {
    flex: 1;
    height: 200px;
  }
`

export const StatText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  ${onMediumScreen()} {
    /* Figma gives every stat's text the same 128px box, so the laurels sit at the same spacing on
       each card; longer translations can still grow it. */
    min-width: 128px;
  }
`

export const StatValue = styled.span`
  font-size: 23px;
  font-weight: 600;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.secondaryDark};
`

export const StatCaption = styled.span`
  font-size: 17px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.secondaryDark};
`

export const Laurel = styled(LaurelIcon)`
  height: 57px;
  width: auto;
  flex-shrink: 0;
`

export const LaurelRight = styled(Laurel)`
  transform: scaleX(-1);
`
